// Station Search default colors and constants
export const WHITE_COLOR = "#FFFFFF";

export const BLACK_COLOR = "#000000";

export const GRAY_COLOR = "#C8DCF0";

export const BLUE_COLOR = "#3B82F6";
